// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"42":"ea38aa42109cefeb","797":"227bdb2bbb3c2a05"}[chunkId] + ".css";
};